/* =========================================================================
   BUMPY VICE — packs (bundles)
   Remise automatique Shopify : 2 produits = -10 %, 3 produits et + = -15 %
   (réductions « PACK DUO » et « PACK TRIO »). Ici on ne fait que l'affichage
   des prix, l'ajout groupé au panier et, sur mobile, la remontée du pack
   juste sous le bouton ÉQUIPER de la fiche produit.
   ========================================================================= */
(function () {
  'use strict';

  var fmt = function (cents) {
    var cfg = window.BumpyConfig || {};
    var mf = cfg.moneyFormat || '€{{amount_with_comma_separator}}';
    var v = (cents / 100).toFixed(2);
    var comma = v.replace('.', ',');
    return mf.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, comma)
             .replace(/\{\{\s*amount\s*\}\}/, v)
             .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
  };

  function rateFor(n) { return n >= 3 ? 15 : n >= 2 ? 10 : 0; }

  function refresh(pack) {
    var items = Array.prototype.slice.call(pack.querySelectorAll('[data-pack-item]'));
    var chosen = items.filter(function (el) {
      var cb = el.querySelector('input[type="checkbox"]');
      return !cb || cb.checked;
    });
    var sum = chosen.reduce(function (t, el) { return t + parseInt(el.dataset.price, 10); }, 0);
    var rate = rateFor(chosen.length);
    var total = Math.round(sum * (100 - rate) / 100);

    items.forEach(function (el) {
      var cb = el.querySelector('input[type="checkbox"]');
      el.classList.toggle('is-off', !!cb && !cb.checked);
    });

    var q = function (s) { return pack.querySelector(s); };
    if (q('[data-pack-old]')) { q('[data-pack-old]').textContent = rate ? fmt(sum) : ''; }
    if (q('[data-pack-total]')) q('[data-pack-total]').textContent = fmt(total);
    if (q('[data-pack-save]')) {
      var saveLabel = pack.dataset.saveLabel || "d'économie";
      q('[data-pack-save]').textContent = rate ? ('-' + rate + ' % · ' + fmt(sum - total) + ' ' + saveLabel) : (pack.dataset.secondLabel || 'Ajoute un 2e produit pour -10 %');
    }
    if (q('[data-pack-count]')) q('[data-pack-count]').textContent = chosen.length;
    var btn = q('[data-pack-add]');
    if (btn) btn.disabled = chosen.length === 0;
  }

  function add(pack, btn) {
    var fd = new FormData();
    var i = 0;
    Array.prototype.slice.call(pack.querySelectorAll('[data-pack-item]')).forEach(function (el) {
      var cb = el.querySelector('input[type="checkbox"]');
      if (cb && !cb.checked) return;
      fd.append('items[' + i + '][id]', el.dataset.variant);
      fd.append('items[' + i + '][quantity]', '1');
      i++;
    });
    if (!i) return;
    if (window.Bumpy && window.Bumpy.addToCart) {
      window.Bumpy.addToCart(fd, btn).catch(function () {});
    } else {
      fetch('/cart/add.js', { method: 'POST', body: fd }).then(function () { window.location.href = '/cart'; });
    }
  }

  /* ---- Mobile : le pack remonte juste sous ÉQUIPER (ordinateur inchangé) ---- */
  var mq = window.matchMedia ? window.matchMedia('(max-width: 989px)') : null;
  var holder = null, packEl = null;

  function place() {
    var pack = packEl || (packEl = document.querySelector('section.fbt [data-pack]'));
    var anchor = document.querySelector('[data-product-root] [data-buy-anchor]');
    if (!pack || !anchor || !mq) return;
    if (!holder) {
      holder = document.createComment('bpack-home');
      pack.parentNode.insertBefore(holder, pack);
    }
    if (mq.matches) {
      if (!pack.classList.contains('bpack--inline')) {
        anchor.parentNode.insertBefore(pack, anchor.nextSibling);
        pack.classList.add('bpack--inline');
      }
    } else if (pack.classList.contains('bpack--inline')) {
      holder.parentNode.insertBefore(pack, holder.nextSibling);
      pack.classList.remove('bpack--inline');
    }
  }

  /* ---- « Souvent achetés ensemble » en haut, à la place du fil d'Ariane ---- */
  var fbtHome = null, fbtTop = null, sec = null, head = null, track = null;

  function placeFbt() {
    if (!sec) {
      sec = document.querySelector('section.fbt');
      head = sec && sec.querySelector('.fbt__head');
      track = sec && sec.querySelector('.fbt__track');
    }
    var product = document.querySelector('[data-product-root] .product');
    if (!head || !track || !product || !mq) return;
    if (!fbtHome) {
      fbtHome = document.createComment('fbt-home');
      head.parentNode.insertBefore(fbtHome, head);
      fbtTop = document.createElement('div');
      fbtTop.className = 'fbt-top';
    }
    /* Mobile et ordinateur : la bande monte en haut de la fiche.
       Sur mobile la section du bas est vide (le pack est remonté) : on la masque. */
    if (!fbtTop.parentNode) {
      fbtTop.appendChild(head);
      fbtTop.appendChild(track);
      product.parentNode.insertBefore(fbtTop, product);
    }
    sec.classList.toggle('is-emptied', mq.matches);
  }

  function tidyMobile() {
    if (!mq || !mq.matches) return;
    /* La description complète est déjà résumée en haut : l'accordéon reste fermé. */
    Array.prototype.slice.call(document.querySelectorAll('.tabs__accordion details[open]')).forEach(function (d) {
      d.removeAttribute('open');
    });
  }

  /* ---- Ajout au panier rapide : pas d'ouverture automatique du panier,
     juste une notification (clic dessus = ouvrir le panier), et jamais
     deux ajouts d'affilée par erreur (double clic). ---- */
  function tuneCart() {
    var B = window.Bumpy;
    if (!B || !B.addToCart || B.__tuned) return;
    B.__tuned = true;
    var cfg = window.BumpyConfig || B.config || {};
    cfg.cartType = 'quick';
    var drawer = document.getElementById('cart-drawer');
    cfg.toastTitle = (drawer && drawer.dataset.toastTitle) || 'AJOUTÉ AU PANIER';
    cfg.toastSubtitle = (drawer && drawer.dataset.toastSubtitle) || 'Touche ici pour voir ton panier';
    var orig = B.addToCart, busy = false, last = 0;
    B.addToCart = function (fd, btn) {
      var now = Date.now();
      if (busy || now - last < 800) return Promise.resolve(null);
      busy = true; last = now;
      var done = function () { busy = false; last = Date.now(); };
      return orig.call(B, fd, btn).then(function (d) { done(); return d; }, function (err) { done(); throw err; });
    };
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('#bumpy-toasts .toast');
    var drawer = document.getElementById('cart-drawer');
    if (!t || t.classList.contains('toast--error') || !drawer || !(window.Bumpy && window.Bumpy.openPanel)) return;
    window.Bumpy.openPanel(drawer);
    t.remove();
  });

  /* ---- Fiche produit : la description ne répète plus Utilisation /
     Ingrédients / Avertissements. Ces paragraphes sont retirés de la
     description et placés dans leur onglet (à la place du texte générique). ---- */
  function splitDescription() {
    var root = document.querySelector('[data-product-root]');
    if (!root || root.dataset.descSplit === 'true') return;
    root.dataset.descSplit = 'true';
    var rules = [
      { key: 'use', re: /^(conseils d.utilisation|utilisation|mode d.emploi)/i, tab: 'tab-use', panel: 'panel-use' },
      { key: 'ing', re: /^ingr[ée]dients/i, tab: 'tab-ing', panel: 'panel-ing' },
      { key: 'warn', re: /^(avertissements?|pr[ée]cautions?)/i, tab: 'tab-warn', panel: 'panel-warn' }
    ];
    var descPanel = root.querySelector('#panel-desc');
    var firstAcc = root.querySelector('.tabs__accordion details .tabs__acc-a');
    var found = {};
    [descPanel, firstAcc].forEach(function (box, idx) {
      if (!box) return;
      Array.prototype.slice.call(box.children).forEach(function (p) {
        if (p.tagName !== 'P') return;
        var s = p.firstElementChild;
        if (!s || (s.tagName !== 'STRONG' && s.tagName !== 'B')) return;
        var label = s.textContent.replace(/\s+/g, ' ').trim();
        for (var i = 0; i < rules.length; i++) {
          if (rules[i].re.test(label)) {
            if (idx === 0 && !found[rules[i].key]) {
              var c = p.cloneNode(true);
              c.removeChild(c.firstElementChild);
              var html = c.innerHTML.replace(/^\s*(:|&nbsp;)?\s*/, '');
              found[rules[i].key] = html.charAt(0).toUpperCase() + html.slice(1);
            }
            p.parentNode.removeChild(p);
            break;
          }
        }
      });
    });
    var accItems = Array.prototype.slice.call(root.querySelectorAll('.tabs__accordion details'));
    rules.forEach(function (r) {
      var html = found[r.key];
      if (!html) return;
      var panel = root.querySelector('#' + r.panel);
      if (panel) panel.innerHTML = '<p>' + html + '</p>';
      var tab = root.querySelector('#' + r.tab);
      var name = tab ? tab.textContent.trim().toLowerCase() : '';
      accItems.forEach(function (d) {
        var q = d.querySelector('summary');
        if (name && q && q.textContent.trim().toLowerCase() === name) {
          var a = d.querySelector('.tabs__acc-a');
          if (a) a.innerHTML = '<p>' + html + '</p>';
        }
      });
    });
  }

  function boot() {
    splitDescription();
    tuneCart();
    flushQueue();
    place();
    placeFbt();
    tidyMobile();
    Array.prototype.slice.call(document.querySelectorAll('[data-pack]')).forEach(function (pack) {
      if (pack.dataset.packReady === 'true') return;
      pack.dataset.packReady = 'true';
      pack.addEventListener('change', function (e) {
        if (e.target.matches('input[type="checkbox"]')) refresh(pack);
      });
      var btn = pack.querySelector('[data-pack-add]');
      if (btn) btn.addEventListener('click', function (e) { e.preventDefault(); add(pack, btn); });
      refresh(pack);
    });
  }

  /* ---- Panier volant : jamais de changement de page ---- */
  function flushQueue() {
    var q = window.__bumpyQueue;
    if (!q || !q.length || !(window.Bumpy && window.Bumpy.addToCart)) return;
    window.__bumpyQueue = [];
    q.forEach(function (f) {
      window.Bumpy.addToCart(new FormData(f), f.querySelector('[data-add-button]')).catch(function () {});
    });
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || e.metaKey || e.ctrlKey) return;
    var href = a.getAttribute('href').split('?')[0].replace(/\/$/, '');
    if (!/^(https?:\/\/[^/]+)?(\/[a-z]{2}(-[a-z]{2})?)?\/cart$/i.test(href)) return;
    var drawer = document.getElementById('cart-drawer');
    if (!(window.Bumpy && window.Bumpy.openPanel) || !drawer) return;
    e.preventDefault();
    window.Bumpy.openPanel(drawer);
  });

  /* Cartes « Souvent achetés ensemble » et suggestions du panier :
     un clic n'importe où sur la carte ajoute le produit et ouvre le panier
     volant, sans quitter la page. */
  document.addEventListener('click', function (e) {
    var card = e.target.closest && e.target.closest('.fbt__card, .upsell-line');
    if (!card || e.metaKey || e.ctrlKey) return;
    if (e.target.closest('button, input, select, textarea')) return;
    var form = card.querySelector('form[data-product-form]');
    if (!form || !(window.Bumpy && window.Bumpy.addToCart)) return;
    e.preventDefault();
    window.Bumpy.addToCart(new FormData(form), form.querySelector('[data-add-button]')).catch(function () {});
  });
  try {
    var st = document.createElement('style');
    st.textContent = '.fbt__card,.upsell-line,#bumpy-toasts .toast{cursor:pointer;pointer-events:auto}';
    document.head.appendChild(st);
  } catch (err) { /* rien */ }

  if (mq) {
    var onMq = function () { place(); placeFbt(); };
    if (mq.addEventListener) mq.addEventListener('change', onMq);
    else if (mq.addListener) mq.addListener(onMq);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
